import { loadingController, modalController } from '@ionic/core';
import { store } from '../store/stencil-redux';

import { formDismissAll, loadExistingForms, loadForm } from '../store/forms/forms.actions';
import { formsSupportUpdateGeometryType } from '../store/formsSupport/formsSupport.actions';
import { initialStore } from '../store/index';
import { getFormsCurrentFormId, getFormsSupportFormCache } from '../store/selectors';
import { CoreoGeometryType, CoreoRecord } from '../types';

const createFormModal = async (id: string, animated: boolean, props: any = {}): Promise<HTMLIonModalElement> => {
  const modal = await modalController.create({
    component: 'app-form',
    componentProps: props,
    backdropDismiss: false,
    showBackdrop: true,
    keyboardClose: false,
    animated,
    cssClass: 'form-modal--container has-controller',
    id
  });

  const didPresentHandler = (event) => {
    const targetModal = event.target as HTMLIonModalElement;
    const form = targetModal.querySelector('app-form');
    if (form) {
      form.isLoaded = true;
    }
  };
  modal.addEventListener('didPresent', didPresentHandler, { once: true });

  return modal;
}

export const startForm = async (id: number, record: CoreoRecord, props: any = {}): Promise<HTMLIonModalElement> => {
  initialStore.dispatch(formDismissAll());
  const form = await initialStore.dispatch(loadForm(id, record, undefined, undefined));
  const modal = await createFormModal(form.uuid, true, props);
  await modal.present();
  return modal;
}

export const resumeForms = async () => {

  const forms = await initialStore.dispatch(loadExistingForms());

  if (forms.length === 0) {
    return;
  }

  const loading = await loadingController.create({
    message: 'Resuming forms...'
  });
  await loading.present();

  const modals: HTMLIonModalElement[] = [];
  for (let i = 0; i < forms.length; i++) {
    const modal = await createFormModal(forms[i].uuid, false, {
      formIdx: i,
      isEdit: true
    });
    modal.classList.add('form-modal--resuming');
    await modal.present();
    modals.unshift(modal);
  }

  for (const modal of modals) {
    modal.classList.remove('form-modal--resuming');
  }

  loading.dismiss();
}

export const setFormGeometryType = (geometryType: CoreoGeometryType) => {
  const formId = getFormsCurrentFormId(store.getState());
  store.getStore().dispatch(formsSupportUpdateGeometryType(formId, geometryType));
}

export const getFormGeometryType = (formId: number): CoreoGeometryType => {
  return getFormsSupportFormCache(formId)(store.getState())?.geometryType;
}
